import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircleIcon } from 'lucide-react';
export function FailedMethodsSection() {
  const methods = ['Pasearlo por horas solo lo mantiene sobre-estimulado y evita el sueño profundo.', "El mito de 'cansarlo mucho para que duerma mejor' en realidad genera más micro-despertares nocturnos.", 'Las rutinas de 2 horas son demasiado largas; para cuando terminas, la ventana de sueño ya se cerró.', 'Confiar solo en el pecho o el biberón crea una dependencia que el bebé reclama cada 45 minutos.'];
  return <section className="py-16 px-6 bg-lavender/10" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <FadeIn data-id="element-23">
          <h2 className="text-3xl sm:text-4xl text-center text-taupe mb-10" data-id="element-24">
            Por qué lo que has intentado no funciona
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-25">
          {methods.map((method, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="flex items-start gap-4 bg-white p-5 rounded-xl shadow-sm" data-id="element-27">
                <XCircleIcon className="w-6 h-6 text-lavender shrink-0 mt-0.5" data-id="element-28" />
                <p className="text-taupe/80 text-lg leading-relaxed" data-id="element-29">
                  {method}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}